import { Controller } from "@hotwired/stimulus"

// Controller para manter o histórico de compras em AJAX,
// atualizando apenas o frame mas preservando/atualizando a URL via History API.
export default class extends Controller {
  static targets = [ "form", "link", "editSection" ]

  connect() {
    this.handleBeforeFetch = this.handleBeforeFetch.bind(this)
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    this.element.addEventListener("turbo:before-fetch-request", this.handleBeforeFetch)
    this.element.addEventListener("turbo:frame-load", this.handleFrameLoad)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.handleBeforeFetch)
    this.element.removeEventListener("turbo:frame-load", this.handleFrameLoad)
  }

  handleBeforeFetch(event) {
    const url = new URL(event.detail.url, window.location.origin)
    // Atualiza a URL da barra de endereço para refletir filtros/página/edição,
    // sem recarregar a página inteira.
    window.history.pushState({}, "", url)
  }

  handleFrameLoad() {
    if (this.hasEditSectionTarget) {
      this.editSectionTarget.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}

